<template>
  <!-- 地址列表 -->
  <div class="address-list-wrap">
    <div class="tips-container">
      <div class="tips" v-if="message && !isLaser">
        <div v-if="distributionMessage" @click="showDelay">
          <span>{{ distributionMessage }}</span>
          <span class="icon-tips" v-if="showIcon"></span>
        </div>
        <template v-else>
          {{ message }}
        </template>
      </div>
    </div>
    <div class="address-list">
      <div
        class="address-list-item"
        v-for="(item, index) in getAddressListData"
        :key="index"
        @click="changeAddress(item, index)"
        role="button"
      >
        <template v-if="activeIndex == index && isActive">
          <img v-if="isDark" src="../images/select-dark.png" alt="已选中" />
          <img v-else src="../images/select.png" alt="已选中" />
        </template>
        <div v-else class="icon" aria-label="未选中">
          <v-icon class="icon-location" name="icon-location"></v-icon>
        </div>
        <!-- <img v-else src="../images/location-gray.png" class="icon" alt="未选中" /> -->
        <div v-if="activeIndex == index && isActive" class="text select">
          {{ item.province }} {{ item.city }} {{ item.area }} {{ item.detailAddress }}
        </div>
        <div v-else class="text">{{ item.province }} {{ item.city }} {{ item.area }} {{ item.detailAddress }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { app } from '@/utils'
import Stickyfill from 'stickyfilljs'
export default {
  name: 'AddressList',
  props: ['getAddressListData', 'message', 'addressData', 'isLaser', 'distributionMessage', 'delayDesc'],
  data() {
    return {
      isActive: true,
      activeIndex: 0,
      isDark: app.getColorScheme()
    }
  },
  computed: {
    showIcon() {
      return /发货晚必赔/.test(this.distributionMessage) && this.delayDesc
    }
  },
  created() {
    this.getActiveAddressIndex()
  },
  methods: {
    // 切换地址
    changeAddress(item, index) {
      this.activeIndex = index
      const { province, city, area, isFromServer, detailAddress } = item
      if (isFromServer && (!province || !city || !area || !detailAddress)) {
        this.$toast('请完善收货地址')
      } else {
        const addressSelectData = {
          province,
          city,
          area,
          isFromServer,
          detailAddress,
          isSwitchAddresses: 1, // 手动切换标识
          id: isFromServer ? item.id : null
        }
        this.$emit('changeAddress', addressSelectData)
      }
    },
    getActiveAddressIndex() {
      const addressData = this.addressData || {}
      this.isActive = true
      this.activeIndex = this.getAddressListData.findIndex(
        item =>
          item.area == addressData.area &&
          item.city == addressData.city &&
          item.province == addressData.province &&
          item.isFromServer == addressData.isFromServer
      )
    },
    showDelay() {
      this.showIcon && this.$emit('showDelay')
    }
  }
}
</script>

<style scoped lang="scss" src="./index.scss" />
